import {combineReducers} from 'redux-immutable';

import visitorReducer from '../../common/js/redux/reducers/visitorReducer';

import chatReducer from './chatReducer';
import customizationReducer from './customization';
import companyReducer from './company';
import totalUnreadEntriesReducer from './totalUnreadEntriesReducer';

const reducers = combineReducers({
    visitor: visitorReducer,
    chat: chatReducer,
    company: companyReducer,
    totalUnreadEntries: totalUnreadEntriesReducer,
    customization: customizationReducer
});

export default reducers;



// WEBPACK FOOTER //
// ./redux/reducers/index.js